import React from 'react';
import { MarcomThemeProvider } from '@components/MarcomThemeProvider';
import { ClassicHeader } from '@layout';
import { ClassicFooter } from './ClassicFooter';

export const ClassicHeaderLayout: React.FC<{}> = ({ children }) => {
  return (
    <MarcomThemeProvider>
      <>
        <ClassicHeader />
        <main>{children}</main>
        <ClassicFooter />
      </>
    </MarcomThemeProvider>
  );
};
